<template>
  <Loader v-if="isLoading"/>
  <ScreenForm action="edit" :slider="slider" :slides="slides" v-else/>
</template>

<script>
import ScreenForm from '@/components/Screen/ScreenForm'
import Slider from '@/model/Slider'
import * as types from '@/store/types.js'
import Loader from '@/components/Utils/Loader'

export default {
  components: {
    ScreenForm, Loader
  },
  computed: {
    slider () {
      this.$store.dispatch(types.ACTIVE_SLIDER)
      return this.$store.getters[types.ACTIVE_SLIDER]
    }
  },
  data () {
    return {
      slides: [],
      isLoading: true
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      Slider.show(this.$route.params.id).then((response) => {
        this.slides = response.data.data.slides
        this.isLoading = false
      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/views/screen/Edit.vue